export default "../css/3e1cc542e719ff4dbb944ecc45a17afa.otf";